export default __webpack_public_path__ + "static/media/7.ac9b2d51.png";